/**
 *  determines the source field for a ModelMappingValue:
 *    `source_value_identifier`,
 *    `mapping_formula`, or
 *    `static_input`
 */
export enum ModelMappingValuesType {
  Value = 1,
  Formula = 2,
  StaticValue = 3,
}